import {Component, ViewChild} from '@angular/core';
import {ViewController} from "ionic-angular";
import {FormBuilder, FormGroup} from "@angular/forms";
import {UserAuthenticationService} from "../../../../user/login/services/user-authentication.service";
import {ImageContentForm} from "../../../image/form/image-content.form";
import {ImageEntity} from "../../../../shared/entities/image/image.entity";
import {ImageCardButtons} from "../../interfaces/image-card-buttons.interface";
import {ImageCardComponent} from "../image-card/image-card.component";

/**
 * Component that contains the Apply to All modal
 * @class
 * @description Used to apply image metadata to all images being uploaded
 */
@Component({
  selector: 'advtech-apply-to-all-modal',
  templateUrl: './apply-to-all-modal.component.html',
})
export class ApplyToAllModalComponent {

  /**
   * Next and Clear buttons
   * @type {Array}
   */
  applyToAllButtons: ImageCardButtons[] = [{
    label: 'Clear All',
    handler: () => this.clearAll(),
    isFull: true,
    color: 'light',
    cssClass: 'left-button',
  }, {
    label: 'Next',
    handler: () => this.next(),
    isFull: true,
    color: 'primary',
    cssClass: 'right-button next-button',
  }];

  /**
   * The image card component
   * @type {ImageCardComponent}
   */
  @ViewChild('imageCard')
  imageCard: ImageCardComponent;

  /**
   * Title of this page
   * @type {string}
   */
  pageTitle: string = 'Apply to All';

  /**
   * The image content form
   * @type {ImageContentForm}
   */
  form: ImageContentForm;

  /**
   * The image form being modified
   * @type {FormGroup}
   */
  formGroup: FormGroup;
  /**
   * The default credit when the image modal appears
   * @type {string}
   */
  creditModel: string;

  /**
   * Initialize empty form
   * @param {ViewController} viewCtrl The ViewController instance
   * @param {FormBuilder} formBuilder The FormBuilder instance
   * @param {UserAuthenticationService} userAuthService The UserAuthenticationService instance
   * @constructor
   */
  constructor(private viewCtrl: ViewController,
              private formBuilder: FormBuilder,
              public userAuthService: UserAuthenticationService) {
    const data = {
      id: '',
      title: '',
      credits: '',
      alt: '',
      caption: '',
      cropGravity: '',
      keywords: [''],
    };
    const imageEntity = new ImageEntity({data});
    this.form = new ImageContentForm(this.formBuilder, imageEntity);

    this.creditModel = localStorage.getItem('displayName');
    if (!this.creditModel) {
      this.userAuthService.getUser().subscribe((userData) => {
        localStorage.setItem('displayName', userData.username);
        this.creditModel = localStorage.getItem('displayName');
      });
    }
  }

  /**
   * Clear all form data
   * @returns {void}
   */
  clearAll(): void {
    const form = this.form;
    form.getForm().patchValue({
      title: '',
      alt: '',
      caption: '',
      credits: '',
      keywords: [],
    });
    this.imageCard.captionInput.quillEditor.quillEditor.pasteHTML('');
  }

  /**
   * Move on to the image page
   * @returns {Promise<any>}
   */
  next(): Promise<any> {
    return this.viewCtrl.dismiss(this.form);
  }

  /**
   * Dismisses the modal
   * @return {Promise<any>}
   */
  dismiss(): Promise<any> {
    return this.viewCtrl.dismiss({status: 'cancel'});
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/apply-to-all-modal/apply-to-all-modal.component.ts